(() => {
  if (window.__kpcAtelierCardsReady) return;
  window.__kpcAtelierCardsReady = true;

  const formatSelection = (quick, button) => {
    if (!quick || !button) return;

    quick.querySelectorAll('[data-kpc-variant]').forEach(item => {
      item.classList.toggle('is-selected', item === button);
      item.setAttribute(
        'aria-pressed',
        item === button ? 'true' : 'false'
      );
    });

    const input = quick.querySelector('[data-kpc-variant-input]');
    const label = quick.querySelector('[data-kpc-selected-label]');
    const price = quick.querySelector('[data-kpc-selected-price]');
    const add = quick.querySelector('[data-kpc-add]');

    const variantId = button.dataset.variantId || '';

    if (input) {
      input.value = variantId;
      input.setAttribute('value', variantId);
    }

    const form = quick.querySelector('form');

    if (form) {
      form.dataset.selectedVariantId = variantId;
    }

    if (label) {
      label.textContent = button.dataset.variantLabel || '';
    }

    if (price) {
      price.textContent = button.dataset.variantPrice || '';
    }

    if (add) {
      add.disabled = !button.dataset.variantId;
    }

    quick.classList.add('is-selected');
  };

  const refreshCartUI = async response => {
    const cartDrawer = document.querySelector('cart-drawer');

    if (
      cartDrawer &&
      typeof cartDrawer.renderContents === 'function' &&
      response.sections
    ) {
      cartDrawer.renderContents(response);
      return true;
    }

    const bubble = document.getElementById('cart-icon-bubble');

    if (
      bubble &&
      response.sections &&
      response.sections['cart-icon-bubble']
    ) {
      const doc = new DOMParser().parseFromString(
        response.sections['cart-icon-bubble'],
        'text/html'
      );

      const next = doc.getElementById('cart-icon-bubble');

      if (next) {
        bubble.innerHTML = next.innerHTML;
      }
    }

    return false;
  };

  const addVariant = async form => {
    const quick = form.closest('.kpc-card-quick');
    const add = form.querySelector('[data-kpc-add]');
    const status = form.querySelector('[data-kpc-status]');
    const input = form.querySelector('[data-kpc-variant-input]');
    const selected = quick?.querySelector(
      '[data-kpc-variant].is-selected'
    );
    const variantId =
      input?.value ||
      form.dataset.selectedVariantId ||
      selected?.dataset.variantId ||
      '';

    if (!variantId || add?.disabled) return;

    if (input) {
      input.value = variantId;
      input.setAttribute('value', variantId);
    }

    const originalText = add.textContent;

    add.disabled = true;
    add.setAttribute('aria-busy', 'true');
    add.textContent = 'Adding…';

    try {
      const formData = new FormData(form);
      formData.set('id', variantId);

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer) {
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      }

      const cartAddPath =
        (window.routes && window.routes.cart_add_url) ||
        form.getAttribute('action') ||
        '/cart/add';
      const endpoint = cartAddPath.endsWith('.js')
        ? cartAddPath
        : cartAddPath.replace(/\/$/, '') + '.js';

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this item.'
        );
      }

      await refreshCartUI(data);

      if (status) {
        status.textContent = 'Added to cart.';
      }

      add.textContent = 'Added ✓';

      setTimeout(() => {
        add.textContent = originalText;
        add.disabled = false;
        add.removeAttribute('aria-busy');
      }, 1400);

    } catch (error) {
      if (status) {
        status.textContent =
          error.message ||
          'Unable to add this item.';
      }

      add.textContent = 'Try again';
      add.disabled = false;
      add.removeAttribute('aria-busy');
    }
  };

  /*
   * Capture phase is intentional.
   *
   * Craft can use an enlarged clickable product-link area around
   * cards. Handling our quick-select controls during capture ensures
   * mobile taps are claimed before any parent card navigation gets
   * the opportunity to respond.
   */
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-kpc-quick-toggle]');

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const quick = toggle.closest('.kpc-card-quick');
      const panel = quick?.querySelector('[data-kpc-quick-panel]');

      if (!panel) return;

      const willOpen = panel.hidden;

      panel.hidden = !willOpen;

      toggle.setAttribute(
        'aria-expanded',
        willOpen ? 'true' : 'false'
      );

      const actionWord =
        toggle.querySelector('[data-kpc-toggle-word]');

      const icon =
        toggle.querySelector('[data-kpc-toggle-icon]');

      if (actionWord) {
        actionWord.textContent =
          willOpen ? 'Close' : (toggle.dataset.kpcToggleLabel || 'Quick select');
      }

      if (icon) {
        icon.textContent = willOpen ? '−' : '+';
      }

      if (willOpen) {
        requestAnimationFrame(() => {
          const firstAvailableVariant =
            panel.querySelector(
              '[data-kpc-variant]:not([disabled])'
            );

          if (
            firstAvailableVariant &&
            typeof firstAvailableVariant.focus === 'function'
          ) {
            firstAvailableVariant.focus({
              preventScroll: true
            });
          }
        });
      }

      return;
    }

    const option =
      event.target.closest('[data-kpc-variant]');

    if (option) {
      event.preventDefault();
      event.stopPropagation();

      if (option.disabled) return;

      const quick =
        option.closest('.kpc-card-quick');

      if (quick) {
        formatSelection(quick, option);
      }

      return;
    }

    const addButton =
      event.target.closest('[data-kpc-add]');

    if (addButton) {
      /*
       * Do not prevent default here because the form submit needs
       * to fire. We only stop the card click from bubbling.
       */
      event.stopPropagation();
      return;
    }

    /*
     * Any other interaction taking place inside the custom quick
     * selector belongs to the selector, not the product-card link.
     */
    const quickControl =
      event.target.closest('.kpc-card-quick');

    if (quickControl) {
      event.stopPropagation();
    }
  }, true);

  /*
   * Extra touch protection for iOS / coarse-pointer devices.
   * We do not call preventDefault here because that can suppress
   * the following click event. We only stop parent handlers.
   */
  document.addEventListener('touchstart', event => {
    if (event.target.closest('.kpc-card-quick')) {
      event.stopPropagation();
    }
  }, {
    capture: true,
    passive: true
  });

  document.addEventListener('submit', event => {
    const form =
      event.target.closest('.kpc-card-form');

    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    addVariant(form);
  }, true);
})();

